import { render } from "./MyPageReviewPost.vue?vue&type=template&id=0303b88c"
import script from "./MyPageReviewPost.vue?vue&type=script&lang=js"
export * from "./MyPageReviewPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__